<template>
  <div class="column" :class="columnSize">
    <b-field
      :label="label"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    />
    <b-field v-for="kpiStatus in kpiStatuses" :key="kpiStatus.value">
      <b-radio
        :value="value"
        :native-value="kpiStatus.value"
        type="is-dark"
        @input="onInput"
      >
        {{ kpiStatus.label }}
      </b-radio>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  data: () => ({
    kpiStatuses: [
      {
        value: "",
        label: "All"
      },
      {
        value: "pass",
        label: "Pass"
      },
      {
        value: "fail",
        label: "Fail"
      },
      {
        value: "pending",
        label: "Pending"
      }
    ]
  }),
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldKpiStatus.vue